import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
import { launchOffer } from '../data/content';
const labels = ['HS', 'MIN', 'SEG'];
export function Urgency() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [hours, minutes, seconds];
  return <section className="border-y border-rust/30 bg-[#1a0f12]" data-id="element-264" data-mp="21x6uc2gbtohx">
      <div className="mx-auto max-w-content px-6 py-14 text-center lg:py-16" data-id="element-265" data-mp="1o7d4phwzz075">
        <h2 className="font-display text-2xl font-semibold uppercase tracking-tight text-parchment sm:text-3xl" data-id="element-266" data-mp="1o58qo75dwkt5">
          ⏰ Precio de lanzamiento — cierra en:
        </h2>

        <div className="mt-6 flex items-end justify-center gap-4 sm:gap-8" role="timer" aria-label="Tiempo restante de la oferta de lanzamiento" data-id="element-267" data-mp="1eaqlexkbkh78">
          {units.map((unit, index) => <div key={labels[index]} data-id="element-268" data-mp="199t56qivdx8d" data-mpi={index}>
              <span className="block font-display text-5xl font-semibold tabular-nums text-rust-soft sm:text-6xl" data-id="element-269" data-mp="198rgvkcufe8p">
                {unit}
              </span>
              <span className="mt-1 block font-sans text-xs font-semibold tracking-[0.18em] text-parchment/50" data-id="element-270" data-mp="2107g7u6rbmyc">
                {labels[index]}
              </span>
            </div>)}
        </div>

        <p className="mt-6 flex items-center justify-center gap-2 font-sans text-base font-semibold text-parchment" data-id="element-271" data-mp="2ayde80pg08xx">
          <AlertTriangleIcon className="h-5 w-5 text-gold-soft" aria-hidden="true" data-id="element-272" data-mp="1n89altc9896x" />
          {launchOffer.increaseWarning}
        </p>

        <div className="mx-auto mt-8 max-w-xl text-left" data-id="element-273" data-mp="1ib981sem5okk">
          <div className="flex items-center justify-between font-sans text-sm" data-id="element-274" data-mp="1wz433fg3g50t">
            <span className="font-semibold text-rust-soft" data-id="element-275" data-mp="1s7vnu2s31pfq">
              ● Cupos al precio de lanzamiento
            </span>
            <span className="font-semibold text-parchment/70" data-id="element-276" data-mp="14hhv0a1obmk3">Quedan pocos</span>
          </div>
          <div className="mt-2 h-2.5 w-full overflow-hidden rounded-full bg-night-line" role="progressbar" aria-valuenow={launchOffer.cuposPercent} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos al precio de lanzamiento ya tomados" data-id="element-277" data-mp="zjzxrgx0qvrx">
            <div className="h-full rounded-full bg-rust" style={{
            width: `${launchOffer.cuposPercent}%`
          }} data-id="element-278" data-mp="1y0yx8p5jtzpw" />
          </div>
          <p className="mt-2 font-sans text-xs text-parchment/50" data-id="element-279" data-mp="168zpz6myjahy">
            {launchOffer.cuposLabel}
          </p>
        </div>
      </div>
    </section>;
}